import React, { useState, useEffect } from "react";
import { Button, Table, Collapse, Row } from "reactstrap";
import { toast } from "react-toastify";
// componentes
import Pagination from "../../../../components/Paginationv3";
import SectionComponent from "../../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../../components/SearchFilters";
import WaitExport from "../../../../components/WaitExport";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";
// service
import { getSurveysReport } from "../../../../utils/services/superScreen";
// utils
import useDebounce from "../../../../utils/hooks/useDebounce";
import { formatDateTime } from "../../../../utils/helpers/files/formatDate";
import { validation } from "../../../../utils/helpers/masks/validations";
import { createXlsx } from "./createXlsx";

const columnsFilter = [
  { name: "Nome do Participante", value: "loginName", type: "text" },
  { name: "Pergunta", value: "question", type: "text" },
  { name: "Resposta", value: "answer", type: "text" },
  { name: "Acertou", value: "hit", type: "text" },
  { name: "Data e Hora", value: "date", type: "date" },
];

// verifica se a data digitada está completa (dd/mm/aaaa) e é válida
function isCompleteDate(value) {
  return (
    /^\d{2}\/\d{2}\/\d{4}$/.test(value) && validation(value, "date").isValid
  );
}

// formata a data de criação da resposta (dd/mm/aaaa hh:mm)
function formatCreatedAt(date) {
  return date ? formatDateTime(date, "/") : "";
}

export default function ReportSurvey(props) {
  // state de paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [countData, setCountData] = useState(0);
  // state de pesquisa
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  // state de filtros
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("loginName");
  // state de dados
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  // state de exportação
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  // state do collapse de opções (mobile)
  const [isOpen, setIsOpen] = useState(false);

  const isDateFilter =
    columnsFilter.find((item) => item.value === activeFilter)?.type === "date";
  // data incompleta ou inválida não dispara a pesquisa
  const invalidDateSearch =
    isDateFilter && debouncedSearch !== "" && !isCompleteDate(debouncedSearch);

  // troca a coluna do filtro e limpa a pesquisa
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // converte a data de dd/mm/aaaa para aaaa-mm-dd quando o filtro é de data
  function treatmentSearch() {
    if (isDateFilter && debouncedSearch !== "") {
      return debouncedSearch.split("/").reverse().join("-");
    }
    return debouncedSearch;
  }

  // atualiza a pesquisa e volta para a primeira página
  function handleSearch(value) {
    setSearch(value);
    setCurrentIndex(1);
  }

  // inicia a exportação do relatório em xlsx
  function exportReport() {
    createXlsx({
      idEvent: props.idEvent,
      idSuperScreen: props.idSuperScreen,
      idReportSurvey: props.idReportSurvey,
      search: treatmentSearch(),
      countData,
      activeFilter,
      setFinishExport,
      setExportInProgress,
    });
    setExportInProgress(true);
  }

  useEffect(() => {
    if (invalidDateSearch) return;

    // ignora respostas de requisições antigas (pesquisa digitada antes)
    let ignore = false;

    setLoading(true);
    getSurveysReport(
      props.idEvent,
      props.idSuperScreen,
      props.idReportSurvey,
      currentIndex,
      itemsPerPage,
      treatmentSearch(),
      activeFilter
    )
      .then((res) => {
        if (ignore) return;

        if (res?.message === "findOne") {
          setReportData(res.findOneTransmissionData.data);
          setCountData(res.findOneTransmissionData.count);
        } else {
          toast.error("Erro ao buscar relatório de enquetes.");
        }
      })
      .catch(() => {
        if (!ignore) toast.error("Erro ao buscar relatório de enquetes.");
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });

    return () => {
      ignore = true;
    };
  }, [currentIndex, itemsPerPage, debouncedSearch]);

  return (
    <div>
      <WaitExport
        isOpen={exportInProgress}
        name="Relatório"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />
      <div>
        <Row
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: 10,
            width: "50px",
          }}
        >
          <SectionComponent
            sectionName="Filtros"
            setIsOpen={setCollapseIsOpen}
            isOpen={collapseIsOpen}
          />
        </Row>
        <Collapse isOpen={collapseIsOpen}>
          <SearchFilters
            columns={columnsFilter}
            activeFilter={activeFilter}
            setActiveFilterHandle={setActiveFilterHandle}
          />
        </Collapse>
      </div>

      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          marginBottom: 10,
          alignItems: "center",
        }}
      >
        <form
          className="app-search d-none d-lg-block events-input-search"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="position-relative">
            <input
              type="text"
              className="form-control"
              placeholder={isDateFilter ? "dd/mm/aaaa" : "Pesquisar..."}
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <span className="bx bx-search-alt" />
          </div>
        </form>

        <div className="mobile-btn-section" style={{ width: "100%" }}>
          <Row className="mobile-btns-top">
            <form
              className="app-search"
              style={{ padding: "0px" }}
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  value={search}
                  className="form-control"
                  placeholder={isDateFilter ? "dd/mm/aaaa" : "Pesquisar..."}
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
          </Row>
          {reportData.length > 0 && (
            <>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <Row className="mobile-btns-top">
                  <div onClick={() => exportReport()}>Exportar relatório</div>
                </Row>
              </Collapse>
            </>
          )}
        </div>

        {reportData.length > 0 && (
          <div className="header-btns-container">
            <Button
              color="success"
              className="btn-rounded waves-effect waves-light events-button-add"
              onClick={() => exportReport()}
            >
              Exportar relatório
            </Button>
          </div>
        )}
      </div>
      {invalidDateSearch && (
        <span className="text-danger d-block mb-2">
          Digite uma data válida no formato dd/mm/aaaa
        </span>
      )}
      <div className="table-responsive mb-3">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>Nome do Participante</th>
              <th>Pergunta</th>
              <th>Resposta</th>
              <th>Acertou</th>
              <th>Data e Hora</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <LoadingSkelentonTable lines={3} cols={5} />
            ) : (
              reportData.map((e) => (
                <tr key={e.id}>
                  <td>{e.loginName}</td>
                  <td>{e.question}</td>
                  <td>{e.answer}</td>
                  <td>{e.hit ? "Sim" : "Não"}</td>
                  <td>{formatCreatedAt(e.createdAt)}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
      <Pagination
        data={reportData}
        search={search}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={countData}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />
    </div>
  );
}
